import React from "react";
import { useInView } from "../../hooks/useInView";
import "./AnimatedSection.css";

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({ children, className = "", delay = 0 }) => {
  const [ref, inView] = useInView(0.1);

  return (
    <div ref={ref} className={`animated-section ${inView ? "animate-in" : ""} ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export default AnimatedSection;
